var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLineEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26188 12.0739C0.934306 12.4018 0.750215 12.8468 0.75 13.3103V17.5C0.75 17.9641 0.934374 18.4092 1.26256 18.7374C1.59075 19.0656 2.03587 19.25 2.5 19.25H18.25C18.8023 19.25 19.25 18.8023 19.25 18.25C19.25 17.6977 18.8023 17.25 18.25 17.25H9.41381L16.6668 9.99526C16.6805 9.98299 16.6939 9.97027 16.7071 9.95711C16.7203 9.94389 16.7331 9.93039 16.7454 9.91663L19.488 7.17344C19.8159 6.84528 20.0001 6.40034 20.0001 5.93641C20.0001 5.47247 19.8154 5.02706 19.4875 4.6989L15.2978 0.51203C14.9697 0.184093 14.5247 -0.00012207 14.0608 -0.00012207C13.5969 -0.00012207 13.1519 0.184095 12.8238 0.512036L1.26188 12.0739ZM10.75 5.41421L2.75 13.4142V17.25H6.58572L14.5848 9.24901L10.75 5.41421ZM12.1642 4L15.9988 7.83463L17.8965 5.93649L14.0608 2.10337L12.1642 4Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLineEdit);
export default __webpack_public_path__ + "static/media/IconLineEdit.75e7bbaaf8a6127ce21b9036b24f8b65.svg";
export { ForwardRef as ReactComponent };